import { theme } from '../../../theme';
import { ThemeProvider } from '@mui/material/styles';
import WalletTable from './WalletTable';
import { Typography } from '@mui/material';

const WalletList = () => {
  return (
    <ThemeProvider theme={theme}>
      <Typography variant="h5" fontWeight="bold" mb={2}>
        Manage Customer Wallet
      </Typography>
      <WalletTable />
    </ThemeProvider>
  );
};

export default WalletList;
